/* ===========================================================
   babypinkdotshop — Countdown engine
   Drives every [data-bp-countdown] element on the page.
   Each block needs a data-target ISO datetime string, and child
   elements with data-days / data-hours / data-mins / data-secs.
   =========================================================== */
(function(){
  function pad(n){ return n.toString().padStart(2,'0'); }

  function tick(){
    var blocks = document.querySelectorAll('[data-bp-countdown]');
    blocks.forEach(function(block){
      var targetStr = block.getAttribute('data-target');
      var target = new Date(targetStr).getTime();
      if(isNaN(target)){ return; }
      var now = new Date().getTime();
      var diff = Math.max(0, target - now);

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);

      var d = block.querySelector('[data-days]');
      var h = block.querySelector('[data-hours]');
      var m = block.querySelector('[data-mins]');
      var s = block.querySelector('[data-secs]');
      if(d) d.textContent = pad(days);
      if(h) h.textContent = pad(hours);
      if(m) m.textContent = pad(mins);
      if(s) s.textContent = pad(secs);

      if(diff <= 0){
        block.classList.add('bp-countdown-ended');
      }
    });
  }
  tick();
  setInterval(tick, 1000);
})();
